export enum DispositivoStatus {
  ATIVO = 'ATIVO',
  INATIVO = 'INATIVO'
}
